import Hero from "../components/hero";

const Home = () => {
  return (
    <section>
      <Hero />
    </section>
  );
};

export default Home;
